const configElement = document.getElementById('cc-delivery-config');
const config = configElement ? JSON.parse(configElement.textContent) : {};
const quantityByVariant = items => {
  const quantities = new Map();
  for (const item of items || []) {
    const id = String(item.variant_id ?? item.id);
    quantities.set(id, (quantities.get(id) || 0) + Number(item.quantity || 0));
  }
  return quantities;
};
let cartQuantities = quantityByVariant(config.items);
const components = new Set();
let refreshTimer;
let refreshVersion = 0;

export function deliverySplit(stock, requested, before = 0) {
  const quantity = Math.max(0, Math.floor(Number(requested) || 0));
  const remaining = Math.max(0, Math.floor(Number(stock) || 0) - Math.max(0, Number(before) || 0));
  const monterrey = Math.min(quantity, remaining);
  return { monterrey, tijuana: quantity - monterrey, remaining };
}

const interpolate = (text, quantity) => String(text || '').replaceAll('__quantity__', String(quantity));
const plural = (key, quantity) => quantity === 1 ? config[`${key}_one`] : interpolate(config[`${key}_other`], quantity);
const refreshCart = () => {
  const version = ++refreshVersion;
  clearTimeout(refreshTimer);
  refreshTimer = setTimeout(async () => {
    try {
      const response = await fetch(`${String(config.root || '/').replace(/\/?$/, '/')}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (version !== refreshVersion || !Array.isArray(cart.items)) return;
      cartQuantities = quantityByVariant(cart.items);
      for (const component of components) component.render();
    } catch {}
  }, 30);
};
document.addEventListener('cart:update', refreshCart);
window.addEventListener('pageshow', event => { if (event.persisted) refreshCart(); });

class CCDeliverySplit extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    components.add(this);
    this.scope = this.dataset.mode === 'cart' ? this.closest('.cart-items__table-row') : this.closest('cc-quick-buy, product-form-component');
    this.scope?.addEventListener('input', () => this.render(), options);
    this.scope?.addEventListener('change', () => this.render(), options);
    this.scope?.addEventListener('quantity-selector:update', () => this.render(), options);
    this.scope?.addEventListener('click', () => requestAnimationFrame(() => { if (this.isConnected) this.render(); }), options);
    this.closest('.shopify-section')?.addEventListener('variant:update', event => {
      const data = event.detail?.data;
      if (this.dataset.mode !== 'product' || String(data?.productId) !== this.dataset.productId) return;
      const replacement = data?.html?.querySelector('cc-delivery-split[data-mode="product"]');
      if (replacement) {
        for (const key of ['variantId', 'stock', 'policy', 'tracked', 'inCart']) this.dataset[key] = replacement.dataset[key];
      } else {
        this.dataset.tracked = 'false';
      }
      requestAnimationFrame(() => { if (this.isConnected) this.render(); });
    }, options);
    this.render();
  }

  disconnectedCallback() {
    this.controller?.abort();
    components.delete(this);
  }

  render() {
    const selector = this.scope?.querySelector('select[name="id"]');
    const selected = selector?.selectedOptions?.[0];
    const id = selector ? selector.value : this.dataset.variantId;
    const source = selected?.value ? selected.dataset : this.dataset;
    const tracked = source.tracked === 'true';
    this.hidden = !tracked || !id;
    if (this.hidden) return;
    const input = this.scope?.querySelector('[name="quantity"], input[data-cart-quantity], input[ref="quantityInput"]');
    const quantity = input ? Number(input.value) : Number(this.dataset.quantity);
    if (!Number.isInteger(quantity) || quantity < 1) return;
    const isCart = this.dataset.mode === 'cart';
    const inCart = cartQuantities.get(String(id)) || 0;
    const before = isCart ? Number(this.dataset.before) : inCart;
    const stock = Number(source.stock);
    const split = deliverySplit(stock, quantity, before);
    const canPreorder = source.policy === 'continue';
    const content = this.querySelector('[data-cc-delivery-content]');
    if (!content) return;
    const lines = [];
    const add = (tag, text, parent) => {
      const element = document.createElement(tag);
      element.textContent = text;
      if (parent) parent.append(element);
      else lines.push(element);
    };
    const group = location => {
      const element = document.createElement('div');
      element.className = `cc-delivery-group cc-delivery-group--${location}`;
      lines.push(element);
      return element;
    };
    if (!isCart) {
      add('small', interpolate(config.available, stock));
      if (inCart > 0) add('small', interpolate(config.in_cart, inCart));
    }
    if (split.monterrey > 0) {
      const monterrey = group('monterrey');
      add('strong', plural('monterrey', split.monterrey), monterrey);
      add('div', config.express, monterrey);
    }
    if (split.tijuana > 0) {
      if (canPreorder) {
        const tijuana = group('tijuana');
        add('strong', plural('tijuana', split.tijuana), tijuana);
        add('div', config.lead, tijuana);
        add('strong', interpolate(config.scope, split.tijuana), tijuana);
      } else {
        add('div', interpolate(config.limit, split.remaining));
      }
    }
    this.classList.toggle('cc-delivery-split--tijuana', split.tijuana > 0 && canPreorder);
    const text = lines.map(line => line.textContent).join('\n');
    if (content.dataset.lastText !== text) {
      content.replaceChildren(...lines);
      content.dataset.lastText = text;
    }
  }
}

if (!customElements.get('cc-delivery-split')) customElements.define('cc-delivery-split', CCDeliverySplit);

